module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-03"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "animated fadeInUp dura_1",
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('ui-title-red', {
    attrs: {
      "textTitle": " ¡Excelente!"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "hidden-xs-only aligner",
    attrs: {
      "xs12": "",
      "sm2": "",
      "md2": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInRight",
    attrs: {
      "imaSize": 300,
      "imaSrc": "design/banco4-2-3",
      "imaAlt": ""
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": 'Gastos fijos, gastos variables y gastos opcionales.',
      "videoEmbed": "ADMINISTRACIONDINERO31GastosFijosVariablesOcasionales.mp4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInUp dura_2 aligner",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('p', {
    staticClass: "text-box adorn-bottom"
  }, [_vm._v("\n       Ahora que tiene claros los diferentes tipos de gasto, está listo para continuar con su presupuesto."), _c('br'), _c('br'), _vm._v("\n       A continuación se presentan tres cuadros en los que podrá ingresar los datos de sus gastos fijos, gastos variables y gastos opcionales.\n      ")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "aligner animated fadeIn dura_2",
    attrs: {
      "xs12": "",
      "sm5": "",
      "md5": "",
      "text-xs-center": ""
    }
  }, [_c('image-app', {
    attrs: {
      "imaSize": 230,
      "imaSrc": "contenido/diapositiva_10",
      "imaAlt": "Mujer sonriendo recostada en el cuadro de texto"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58dd39f9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-31.vue
// module id = 1002
// module chunks = 1